import ExistingChat from "../fetch/ExistingChat.tsx";
import IfItemStatus from "../../item/coditions/IfItemStatus.tsx";
import { SubmitProvider } from "../../../context/context.submit.tsx";
import {
  IconMessage2Plus,
  IconMessage2Question,
  IconMessages,
} from "@tabler/icons-react";
import CreateChat from "../auth/CreateChat.tsx";
import { Link } from "react-router-dom";
import { ROUTE_CHAT } from "../../../const/routes.ts";
import { ITEM_STATUS } from "../../../types/Item.ts";

const ContactUser = ({ id }: { id: string }) => {
  return (
    <ExistingChat
      itemId={id}
      ifNoChat={
        <IfItemStatus
          id={id}
          fallback={null}
          acceptedStatus={[ITEM_STATUS.ACTIVE, ITEM_STATUS.HIDDEN]}
        >
          <SubmitProvider>
            <CreateChat
              key={id}
              fallback={
                <button className="btn rounded-full btn-disabled">
                  <IconMessage2Question stroke={2} />
                </button>
              }
              itemId={id}
            >
              {(handleClick) => (
                <button
                  className="btn btn-info w-full rounded-full grow"
                  onClick={handleClick}
                >
                  kontaktieren
                  <IconMessage2Plus className="opacity-75" stroke={2} />
                </button>
              )}
            </CreateChat>
          </SubmitProvider>
        </IfItemStatus>
      }
    >
      {(chat) => (
        <Link className="btn rounded-full text-info" to={ROUTE_CHAT(chat._id)}>
          <IconMessages className="opacity-75" stroke={2} />
          chat
        </Link>
      )}
    </ExistingChat>
  );
};
export default ContactUser;
